import { Directive, ElementRef, HostListener, Input, OnChanges, OnInit, inject } from '@angular/core';
import { MatTooltip, TooltipPosition } from '@angular/material/tooltip';

@Directive({
  selector: '[appTooltipOnTruncate]',
  standalone: true,
  hostDirectives: [MatTooltip]
})
export class TooltipOnTruncateDirective implements OnInit, OnChanges {
  @Input() appTooltipOnTruncate = '';
  @Input() tooltipPosition: TooltipPosition = 'above';

  private tooltip = inject(MatTooltip);
  private el = inject(ElementRef<HTMLElement>);

  ngOnInit(): void {
    this.tooltip.message = this.appTooltipOnTruncate;
    this.tooltip.showDelay = 500;
    this.tooltip.position = this.tooltipPosition;
    this.tooltip.disabled = true;
  }

  ngOnChanges(): void {
    this.tooltip.message = this.appTooltipOnTruncate;
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    const el = this.el.nativeElement;
    this.tooltip.disabled = el.scrollWidth <= el.clientWidth;
  }
}
